module.exports = __webpack_public_path__ + "static/img/vip.367e230.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/vip.png
// module id = gcqy
// module chunks = 1